import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { UsersService } from '../../users/users.service';
import { BaseService } from '../../shared/base.service';
import { HomeService } from '../home.service';
import { MaintenanceService } from '../../maintenance/maintenance.service';
import { AppService } from '../../app.service';
import { UserModel } from '../../users/user.model';
import { HomeComponent } from '../home.component';
import { MaintenanceComponent } from '../../maintenance/maintenance.component';
import { UsersComponent } from '../../users/users.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from '../../dialog/dialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ClinicsService } from '../../clinics/clinics.service';
import * as moment from 'moment';
import { SecureApi } from '../../core/secure.api';
import { IMyDpOptions, IMyInputFieldChanged, IMyInputFocusBlur } from 'mydatepicker';
import { IMyDrpOptions } from 'mydaterangepicker';
import { CoreService} from "../../core/core.service";
import { Daterangepicker } from 'ng2-daterangepicker';

@Component({
    selector: 'b2c-admin-component',
    templateUrl: './b2c-admin.component.html',
    styleUrls: [
        '../home.component.scss',
        './b2c-admin.component.scss'
    ],
    providers: [UsersService, BaseService, HomeService, MaintenanceService, MaintenanceComponent]
})

export class B2CAdminComponent extends HomeComponent implements OnInit {

    @ViewChild('usersComponent', { static: false }) usersComponent: UsersComponent;
    patients: Object[];

    openModal = false;
    clinics: any;
    clinicId = 0;
    userRoleId = 0;
    isFiltered = false;
    showTestData = false;
    sortUsingApi = false;
    today = moment();
    filterType = {
        TIME: 'time',
        MONTH: 'month',
        YEAR: 'year',
        AGE: 'age',
        ALL: 'all'
    };
    startDate = moment().subtract(29, 'days').format('YYYY-MM-DD');
    endDate = moment().format('YYYY-MM-DD');
    filterParams = {
        clinicId: 0,
        startDate: this.startDate,
        endDate: this.endDate,
    };
    filters: any;
    years = [moment().year(), moment().year() - 1];
    months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    dateFormat: string = 'DD.MM.YYYY';
    showModalSetting = false;
    isValidDueDate: boolean = true;
    validateCssDueDate: string = 'form-unfocused';
    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent) {
        super(authService, router, translate, baseService, appService, usersService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.userRoleId = this.authService.user['role_id'];
        this.searchInfo = new UserModel();
        this.url = 'home';
        this.setFilters();
        this.coreService.className = 'fluid';
    }

    filterByClinic(clinicId) {
        const params = {
            clinicId: clinicId
        };
        return this.setFilterParams(params);
    }

    setFilterParams(params: any, value = null){
        if(!params){
            return this.setFilters();
        }

        for(let key in params){
            this.filterParams[key] = params[key];
        }
        this.setFilters();

        /**
         * Only get Data in details page
         */
        if(params.isUpdated){
            return this.getItems();
        }
    }

    setFilters(): string {
        let filters = '';
        let isFirstFilter = true;
        for (const key in this.filterParams) {
            if (isFirstFilter) {
                isFirstFilter = false;
            } else {
                filters += '&';
            }
            filters += key + '=' + this.filterParams[key];
        }

        this.filters = filters;
        return this.filters;
    }

    toggleMaintenance() {
        this.form.value.value = !this.form.value.value;
    }

    toggleNotification() {
        this.form.value.show_release_notification = !this.form.value.show_release_notification;
    }

    /**
     * @param params
     */
    openFormModal(params: Object) {
        this.initForm(params);

        if (params['url'] && params['url'] !== "") {
            this.url = params['url'];
        }

        this.maintenanceService.read(params['id'])
            .subscribe(
                response => {
                    let item = response['maintain'];
                    let notification = response['notification'];
                    let releaseDate = response['release_date'];
                    let releaseNotificationTextEN = response['release_notification_text_en_GB'];
                    let releaseNotificationTextDE = response['release_notification_text_de_CH'];
                    let form = {};
                    let disabled = params['action'] === 'read' ? true : false;

                    if (item.hasOwnProperty('text')) {
                        form['text'] = { value: item['text'], disabled: disabled };
                    }
                    if (item.hasOwnProperty('value')) {
                        form['value'] = item['value'];
                    }

                    if (notification.hasOwnProperty('value')) {
                        form['new_feature_notification'] = notification['value'];
                    }

                    if (releaseDate.hasOwnProperty('text') && releaseDate['text'] != '') {
                        let date = moment(releaseDate['text'], this.dateFormat);
                        form['release_date'] =  {
                            date: {
                                day: date.format('D'),
                                month: date.format('M'),
                                year: date.format('Y')
                            },
                            formatted: releaseDate['text']
                        };
                    } else {
                        form['release_date'] = '';
                    }

                    if (releaseNotificationTextEN.hasOwnProperty('text')) {
                        form['release_notification_text_en_GB'] = releaseNotificationTextEN['text'];
                    }

                    if (releaseNotificationTextDE.hasOwnProperty('text')) {
                        form['release_notification_text_de_CH'] = releaseNotificationTextDE['text'];
                    }

                    if (this.form != null) {
                        this.form.reset(form);
                    } else {
                        this.form = this.fb.group(form);
                    }
                    this.showModal();
                });
    }

    submitSetting(data, valid) {
        if (data['release_date'] && data['release_date'].formatted) {
            data['release_date'] = data['release_date'].formatted;
        } else {
            data['release_date'] = '';
        }
        this.submit(data, valid, 'settings')
    }

    onDateInputChanged(event) {
        if (event.value) {
            return;
        }

        let params = {
            startDate :  moment(event.start).format('YYYY-MM-DD'),
            endDate :  moment(event.end).format('YYYY-MM-DD'),
        };
        this.setFilterParams(params);
        this.isUpdated = true;
        this.coreService.className = 'fluid';
    }
    
    initPageSize(isHome) {
        this.page = 1;
        this.itemsPerPage = 15;
        if(isHome){
            this.itemsPerPage = 5;
        }
        if (this.modalIsClosed) {
            this.modalIsClosed = false;
        }
    }

    initSorting() {
        this.sortedColumn = 'created_at_sort';
        this.order = 'desc';
        this.orderField = ['-created_at_sort'];
        this.sortIsActivated = true;
        this.coreService.className = 'fluid';
    }

    initFilter(isHome, params) {
        if (params['page'] != null) {
            this.currentPage = +params['page'];
        }
        if (params['items'] != null) {
            this.itemsPerPage = +params['items'];
        }
        // process filters like search keyword, role/ clinic id, sort column, sort order
        if (params['filters'] != null) {
            this.filters = [];
            const filters = params['filters'].split('--');
            for (const filter of filters) {
                const splitFilter = filter.split('-');
                if (splitFilter[0] === 'sort') {
                    this.sortedColumn = splitFilter[1];
                } else if (splitFilter[0] === 'order') {
                    this.order = splitFilter[1];
                } else {
                    this.searchInfo[splitFilter[0]] = splitFilter[1];
                    // assign the search filters
                    if (splitFilter[0] !== 'keyword') {
                        this.filters.push({key: splitFilter[0]});
                    }
                }
                if (splitFilter[0] === 'clinic_id') {
                    this.clinicId = splitFilter[1];
                }
            }
        }
        for (const param in params) {
            if (params.hasOwnProperty(param) && param !== 'page' && param !== 'items' && param !== 'filters') {
                this.params[param] = params[param];
            }
        }
        if(!isHome){
            return this.getItems();
        }
    }
 
    switchTestData(event){
        this.showTestData = event && event.checked;
        let params = {
            test : this.showTestData
        };

        return this.setFilterParams(params);
    }

    handleAddUser() {
        this.usersComponent.openFormModal({ action: 'create', title: 'Add User', url: '/home' });
    }

    getFormatedDate(date){
        return moment(date, this.dateFormat);
    }

    onDueDateInputChanged(event: IMyInputFieldChanged) {
        this.isValidDueDate = event.valid;
    }

    /**
     * Handle focus in and focus out input
     * @param {IMyInputFocusBlur} event
     */
    onDueDateFocusBlur(event: IMyInputFocusBlur): void {
        if (event.reason == 2 && !this.isValidDueDate) {
            this.validateCssDueDate = 'form-errored';
        } else if (event.reason == 2) {
            this.validateCssDueDate = 'form-unfocused';
        } else {
            this.validateCssDueDate = 'form-focused mat-focused';
        }
    }

    clipboard(code, pop){
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (code));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        setTimeout(function(){
            pop.hide();
        },1000);
    }

    isExpired(date){
        const now = moment();
        return moment(date, 'DD.MM.YYYY').isBefore(now);
    }

    get isClinicView() {
        return this.clinicId;
    }

    isB2CAdminRole(){
        return this.userRoleId === this.authService.ROLES.B2C_ADMIN;
    }

    clearSearch() {
        this.searchInfo.keyword = '';
    }
}
